<template>
    <el-container>
        <el-header>
            <div class="title">预约挂号管理中心</div>
            <div class="back">
                <img src="/images/u2705.svg" />
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">{{ adminName }}<i class="el-icon-arrow-down el-icon--right"
                            style="color: #000"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><span @click="goBack">退出登录</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-dialog title="提示" :visible.sync="dialogVisibleBack" width="380px">
                <span><i class="el-icon-warning-outline" style="margin-right: 10px"></i>是否确认退出??</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisibleBack = false">取 消</el-button>
                    <el-button type="warning" @click="readGoBack">确 定</el-button>
                </span>
            </el-dialog>
        </el-header>
        <el-container>
            <el-aside width="240px">
                <el-menu background-color="#1a7cff" text-color="#fff" active-text-color="#fff" :unique-opened="true"
                    :router="true" :default-active="menu">
                    <el-menu-item index="/index" @click="saveMenu('/index')">
                        <i class="el-icon-s-home"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <el-submenu index="7" v-if="hasModulePermission('访问跟踪')">
                        <template slot="title">
                            <i class="el-icon-data-line"></i>
                            <span>访问跟踪</span>
                        </template>
                        <el-menu-item index="/visit/report" @click="saveMenu('/visit/report')">访问跟踪</el-menu-item>
                        <el-menu-item index="/visit/userSource" @click="saveMenu('/visit/userSource')">来源统计</el-menu-item>
                    </el-submenu>
                    <el-submenu index="2" v-if="hasModulePermission('预约管理')">
                        <template slot="title">
                            <i class="el-icon-phone"></i>
                            <span>预约管理</span>
                        </template>
                        <el-menu-item index="/makeList" @click="saveMenu('/makeList')" v-if="hasSubModulePermission('预约管理', '预约挂号')">预约挂号</el-menu-item>
                        <el-menu-item index="/Scheduling" @click="saveMenu('/Scheduling')" v-if="hasSubModulePermission('预约管理', '医生排班')">医生排班</el-menu-item>
                        <el-menu-item index="/doctorMakeList" @click="saveMenu('/doctorMakeList')" v-if="hasSubModulePermission('预约管理', '医生名下')">医生名下</el-menu-item>
                </el-submenu>
                <el-submenu index="3" v-if="hasModulePermission('人员科室')">
                    <template slot="title">
                        <i class="el-icon-s-check"></i>
                        <span>人员科室</span>
                    </template>
                        <el-menu-item index="/dep/hospital" @click="saveMenu('/dep/hospital')" v-if="hasSubModulePermission('人员科室', '分院管理')">分院管理</el-menu-item>
                        <el-menu-item index="/dep/depOne" @click="saveMenu('/dep/depOne')" v-if="hasSubModulePermission('人员科室', '一级科室')">一级科室</el-menu-item>
                        <el-menu-item index="/dep/depTwo" @click="saveMenu('/dep/depTwo')" v-if="hasSubModulePermission('人员科室', '二级科室')">二级科室</el-menu-item>
                        <el-menu-item index="/dep/doctor" @click="saveMenu('/dep/doctor')" v-if="hasSubModulePermission('人员科室', '医生管理')">医生管理</el-menu-item>
                        <el-menu-item index="/dep/doctorTitle" @click="saveMenu('/dep/doctorTitle')" v-if="hasSubModulePermission('人员科室', '职称管理')">职称管理</el-menu-item>
                    </el-submenu>
                <el-submenu index="4" v-if="hasModulePermission('医院信息')">
                    <template slot="title">
                        <i class="el-icon-s-platform"></i>
                        <span>医院信息</span>
                    </template>
                    <el-menu-item index="/systemInfo/swiper" @click="saveMenu('/systemInfo/swiper')" v-if="hasSubModulePermission('医院信息', '轮播图设置')">轮播图设置</el-menu-item>
                    <el-menu-item index="/systemInfo/navigation" @click="saveMenu('/systemInfo/navigation')" v-if="hasSubModulePermission('医院信息', '医院导航')">医院导航</el-menu-item>
                    <el-menu-item index="/systemInfo/notice" @click="saveMenu('/systemInfo/notice')" v-if="hasSubModulePermission('医院信息', '医院公告')">医院公告</el-menu-item>
                    <el-menu-item index="/systemInfo/encyclopedias" @click="saveMenu('/systemInfo/encyclopedias')" v-if="hasSubModulePermission('医院信息', '健康百科')">健康百科</el-menu-item>
                    <el-menu-item index="/systemInfo/share" @click="saveMenu('/systemInfo/share')" v-if="hasSubModulePermission('医院信息', '文章分享')">文章分享</el-menu-item>
                    <el-menu-item index="/systemInfo/addDrticle" @click="saveMenu('/systemInfo/addDrticle')" v-if="hasSubModulePermission('医院信息', '文章分享')">发布文章</el-menu-item>
                    <el-menu-item index="/systemInfo/messageType" @click="saveMenu('/systemInfo/messageType')" v-if="hasSubModulePermission('医院信息', '消息类型')">消息类型</el-menu-item>
                    <el-menu-item index="/systemInfo/diseaseType" @click="saveMenu('/systemInfo/diseaseType')" v-if="hasSubModulePermission('医院信息', '疾病类型')">疾病类型</el-menu-item>
                    <el-menu-item index="/systemInfo/homePageConfig" @click="saveMenu('/systemInfo/homePageConfig')" v-if="hasSubModulePermission('医院信息', '首页功能登录控制')">首页登录控制</el-menu-item>
                    <el-menu-item index="/systemInfo/startConfig" @click="saveMenu('/systemInfo/startConfig')" v-if="hasSubModulePermission('医院信息', '启动跳转配置') || isSuperAdmin()">启动跳转配置</el-menu-item>
                    <el-menu-item index="/systemInfo/serviceMenu" @click="saveMenu('/systemInfo/serviceMenu')" v-if="hasSubModulePermission('医院信息', '服务菜单')">服务菜单</el-menu-item>
                    <el-menu-item index="/systemInfo/feedback" @click="saveMenu('/systemInfo/feedback')" v-if="hasSubModulePermission('医院信息', '用户反馈')">用户反馈</el-menu-item>
                    <el-menu-item index="/systemInfo/review" @click="saveMenu('/systemInfo/review')" v-if="hasSubModulePermission('医院信息', '医生评价')">医生评价</el-menu-item>
                </el-submenu>
                <el-submenu index="5" v-if="hasModulePermission('用户管理')">
                    <template slot="title">
                        <i class="el-icon-user-solid"></i>
                        <span>用户管理</span>
                    </template>
                    <el-menu-item index="/users/userlist" @click="saveMenu('/users/userlist')" v-if="hasSubModulePermission('用户管理', '用户管理')">用户管理</el-menu-item>
                    <el-menu-item index="/users/depList" @click="saveMenu('/users/depList')" v-if="hasSubModulePermission('用户管理', '就诊人管理')">就诊人管理</el-menu-item>
                    <el-menu-item index="/users/Message" @click="saveMenu('/users/Message')" v-if="hasSubModulePermission('用户管理', '消息管理')">消息管理</el-menu-item>
                </el-submenu>
                <el-submenu index="6" v-if="hasModulePermission('系统设置')">
                    <template slot="title">
                        <i class="el-icon-s-tools"></i>
                        <span>系统设置</span>
                    </template>
                    <el-menu-item index="/set/administrators" @click="saveMenu('/set/administrators')" v-if="hasSubModulePermission('系统设置', '管理员列表')">管理员列表</el-menu-item>
                    <el-menu-item index="/set/addAdmin" @click="saveMenu('/set/addAdmin')" v-if="hasSubModulePermission('系统设置', '添加管理员')">添加管理员</el-menu-item>
                    <el-menu-item index="/admin/permission" @click="saveMenu('/admin/permission')" v-if="hasSubModulePermission('系统设置', '权限管理')">权限管理</el-menu-item>
                    <el-menu-item index="/set/emailConfig" @click="saveMenu('/set/emailConfig')" v-if="hasSubModulePermission('系统设置', '通知配置')">通知配置</el-menu-item>
                    <el-menu-item index="/set/subscribeConfig" @click="saveMenu('/set/subscribeConfig')" v-if="hasSubModulePermission('系统设置', '订阅消息配置') || isSuperAdmin()">订阅消息配置</el-menu-item>

                </el-submenu>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import { EventBus } from '../eventBus.js';
export default {
    data() {
        return {
            adminName: '',
            dialogVisibleBack: false,
            menu: '',
            permissions: {}
        }
    },
    mounted() {
        this.adminName = localStorage.getItem('adminName')
        this.loadPermissions()
        console.log('当前权限数据:', this.permissions)
    },
    created() {
        this.menu = localStorage.getItem('menu')
        EventBus.$on('menu-changed', (newMenu) => {
            this.menu = newMenu;
        });
    },
    methods: {
        loadPermissions() {
            try {
                const permStr = localStorage.getItem('adminPermissions')
                console.log('原始权限字符串:', permStr)
                this.permissions = permStr ? JSON.parse(permStr) : {}
                console.log('解析后权限对象:', this.permissions)
            } catch (e) {
                this.permissions = {}
                console.error('解析权限失败:', e)
            }
        },
        hasModulePermission(moduleName) {
            console.log('检查模块权限:', moduleName)
            console.log('当前权限数据:', this.permissions)
            
            const cleanModuleName = moduleName.replace(/\s+/g, '')
            console.log('清理后的模块名称:', cleanModuleName)
            
            for (const key in this.permissions) {
                const cleanKey = key.replace(/\s+/g, '')
                console.log('比较:', cleanKey, '===', cleanModuleName, '?', cleanKey === cleanModuleName)
                if (cleanKey === cleanModuleName) {
                    const modulePerms = this.permissions[key]
                    const hasPerm = modulePerms && Object.keys(modulePerms).length > 0
                    console.log('模块', moduleName, '有权限:', hasPerm)
                    return hasPerm
                }
            }
            console.log('模块', moduleName, '没有找到匹配的权限')
            return false
        },
        hasSubModulePermission(moduleName, subModuleName) {
            const cleanModuleName = moduleName.replace(/\s+/g, '')
            const cleanSubModuleName = subModuleName.replace(/\s+/g, '')
            
            if (this.permissions[cleanModuleName]) {
                const modulePerms = this.permissions[cleanModuleName]
                if (modulePerms[cleanSubModuleName] && modulePerms[cleanSubModuleName].includes('查看')) {
                    return true
                }
                if (modulePerms[''] && modulePerms[''].includes('查看')) {
                    return true
                }
            }
            return false
        },
        /**
         * 精确子模块权限（不做空权限兜底），用于数据登记
         */
        hasExactSubModulePermission(moduleName, subModuleName) {
            const cleanModuleName = moduleName.replace(/\s+/g, '')
            const cleanSubModuleName = subModuleName.replace(/\s+/g, '')
            if (this.permissions[cleanModuleName]
                && this.permissions[cleanModuleName][cleanSubModuleName]
                && this.permissions[cleanModuleName][cleanSubModuleName].includes('查看')) {
                return true
            }
            return false
        },
        goBack() {
            this.dialogVisibleBack = true
        },
        readGoBack() {
            this.dialogVisibleBack = false
            localStorage.setItem('adminName', '')
            localStorage.setItem('tokenStartTime', '')
            localStorage.setItem('menu', '')
            localStorage.setItem('adminPermissions', '')
            this.$router.push('/login')
        },
        saveMenu(menu) {
            localStorage.setItem('menu', menu)
            this.menu = menu
        },
        isSuperAdmin() {
            // 超级管理员ID为1
            const adminId = localStorage.getItem('adminId')
            return adminId === '1' || adminId === 1
        },
    },
}
</script>
<style lang="less" scoped>
.el-header {
    background-color: #fff;
    padding: 0;
    height: 60px;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .title {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-left: 30px;
    }

    .back {
        display: flex;
        align-items: center;
        margin-right: 30px;
        font-size: 14px;
        color: #999;

        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 10px;
        }

        .el-dropdown-link {
            cursor: pointer;
            color: #333;
        }
    }
}

.el-aside {
    background-color: #1a7cff;

    .el-menu {
        border-right: none;
        height: 100%;
    }

    .el-submenu__title {
        background-color: transparent !important;
        color: #fff !important;
    }

    .el-menu-item {
        color: #fff !important;
    }

    .el-menu-item:hover,
    .el-submenu__title:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
    }

    .el-menu-item.is-active {
        background-color: rgba(255, 255, 255, 0.2) !important;
    }
}

.el-main {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 60px);
}
</style>
